import { render, staticRenderFns } from "./FormItemUnsupported.vue?vue&type=template&id=39d2bbfe&scoped=true"
import script from "./FormItemUnsupported.vue?vue&type=script&lang=js"
export * from "./FormItemUnsupported.vue?vue&type=script&lang=js"
import style0 from "./FormItemUnsupported.vue?vue&type=style&index=0&id=39d2bbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d2bbfe",
  null
  
)

export default component.exports